// UI strings (English and Spanish); the editor itself follows the browser language too.
const en = {
    tagline: 'Edit eXeLearning resources stored on GitHub and save them back to the repository.',
    repoLabel: 'GitHub repository',
    seeAll: 'See all your resources',
    seeAllHint: 'Sign in and you will see the eXeLearning resources in your repositories, with their screenshot, ready to edit.',
    orOpen: 'or open one directly',
    publicHint: 'Public repositories open without signing in; you will be asked to sign in to save.',
    otherRepo: 'Is the resource in another repository?',
    signedInAs: '{summary} · signed in as {login}',
    open: 'Open',
    opening: 'Opening {repo}…',
    loadingEditor: 'Loading the editor…',
    save: 'Save to GitHub',
    saving: 'Saving…',
    saved: 'Saved',
    unsaved: 'Unsaved changes',
    noChanges: 'No changes to save',
    download: 'Download .elpx',
    copyBadge: 'Copy README badge',
    badgeCopied: 'Badge copied: paste it in your README.',
    openOther: 'Open another repository',
    logout: 'Sign out of GitHub',
    commitMessage: 'Commit message',
    defaultMessage: 'Update the eXeLearning resource',
    filesToSave: 'Files to save',
    deleteRemoved: 'Also delete {n} file(s) no longer used by the resource',
    writeSite: 'Also save the exported website ({n} changed file(s): index.html, html/…)',
    siteHelpTitle: 'Exported website or Pages workflow?',
    siteHelpCommitTitle: 'Save the exported website:',
    siteHelpCommit: 'index.html, html/ and libs/ go into the repository in the same commit. The website is up to date as soon as you save, wherever it is served from (Pages from a branch, another server, a download), but each save changes many files and the history gets noisy.',
    siteHelpActionTitle: 'Pages workflow (⋯ → Publish on GitHub Pages):',
    siteHelpAction: 'the repository keeps only the source, and GitHub rebuilds the website with the official eXeLearning export and publishes it a minute or two after each save. Clean history, but it is set up once per repository and only publishes on GitHub Pages.',
    siteHelpTip: 'Use one or the other: with the workflow, leave this option unticked.',
    asPullRequest: 'Create a branch for this change and start a pull request',
    toBranch: 'Commit directly to the {branch} branch',
    protectedNote: '{branch} is protected: the change will be proposed as a pull request.',
    experimental: 'Experimental feature',
    source: 'Source code',
    yourRepos: 'Your eXeLearning resources',
    summary: '{n} resource(s) in {r} repositories',
    searchingMore: 'Looking for resources in {n} more repositories…',
    edit: 'Edit',
    noScreenshot: 'No screenshot',
    otherRepos: 'Repositories without eXeLearning resources ({n})',
    gridView: 'Grid',
    listView: 'List',
    searching: 'looking for resources…',
    noResource: 'no eXeLearning resource',
    root: 'root',
    private: 'private',
    moreAccess: 'Give eXeLearning access to more repositories',
    noRepos: 'The eXeLearning app has no access to any repository yet.',
    publishPages: 'Publish on GitHub Pages…',
    viewSite: 'View website',
    pagesTitle: 'Publish on GitHub Pages',
    pagesIntro: 'GitHub can rebuild and publish the website every time you save. Do these two steps once in this repository:',
    pagesWorkflow: 'Add the publishing workflow (GitHub opens it ready: press "Commit changes")',
    pagesSettings: 'In Settings → Pages, choose Source: "GitHub Actions"',
    pagesResult: 'The website will be at {url}',
    close: 'Close',
    cancel: 'Cancel',
    committed: 'Saved in {branch}.',
    pullRequest: 'Pull request opened.',
    view: 'View on GitHub',
    loginNeeded: 'Sign in with GitHub to continue.',
    installNeeded: 'Give the eXeLearning app access to {repo} in the GitHub window.',
    noAccess: 'The eXeLearning app cannot write to {repo}. Install it there, or download the .elpx.',
    noProject: 'No eXeLearning project (content.xml) in {repo}{path}.',
    pickFolder: 'Projects found in this repository:',
    rateLimited: 'GitHub limits anonymous use. Sign in with GitHub to continue.',
    notFound: 'Repository not found. If it is private, sign in with GitHub.',
    signIn: 'Sign in with GitHub',
    leaveWarning: 'There are unsaved changes.',
    error: 'Error: {message}',
    notConfigured: 'Saving to GitHub is not configured on this server.',
};

const es: typeof en = {
    tagline: 'Edita recursos de eXeLearning guardados en GitHub y guárdalos de nuevo en el repositorio.',
    repoLabel: 'Repositorio de GitHub',
    seeAll: 'Ver todos tus recursos',
    seeAllHint: 'Inicia sesión y verás los recursos de eXeLearning de tus repositorios, con su captura, listos para editar.',
    orOpen: 'o abre uno directamente',
    publicHint: 'Los repositorios públicos se abren sin iniciar sesión; para guardar te la pediremos.',
    otherRepo: '¿El recurso está en otro repositorio?',
    signedInAs: '{summary} · conectado como {login}',
    open: 'Abrir',
    opening: 'Abriendo {repo}…',
    loadingEditor: 'Cargando el editor…',
    save: 'Guardar en GitHub',
    saving: 'Guardando…',
    saved: 'Guardado',
    unsaved: 'Cambios sin guardar',
    noChanges: 'No hay cambios que guardar',
    download: 'Descargar .elpx',
    copyBadge: 'Copiar badge para el README',
    badgeCopied: 'Badge copiado: pégalo en tu README.',
    openOther: 'Abrir otro repositorio',
    logout: 'Cerrar sesión de GitHub',
    commitMessage: 'Mensaje del commit',
    defaultMessage: 'Actualiza el recurso de eXeLearning',
    filesToSave: 'Ficheros que se guardan',
    deleteRemoved: 'Borrar también {n} fichero(s) que el recurso ya no usa',
    writeSite: 'Guardar también la web exportada ({n} fichero(s) cambiado(s): index.html, html/…)',
    siteHelpTitle: '¿Web exportada o workflow de Pages?',
    siteHelpCommitTitle: 'Guardar la web exportada:',
    siteHelpCommit: 'index.html, html/ y libs/ se guardan en el repositorio en el mismo commit. La web está al día en cuanto guardas, la sirvas desde donde la sirvas (Pages desde una rama, otro servidor, una descarga), pero cada guardado cambia muchos ficheros y el historial se llena de ruido.',
    siteHelpActionTitle: 'Workflow de Pages (⋯ → Publicar en GitHub Pages):',
    siteHelpAction: 'el repositorio guarda solo la fuente y GitHub regenera la web con la exportación oficial de eXeLearning y la publica uno o dos minutos después de cada guardado. Historial limpio, pero hay que configurarlo una vez por repositorio y solo publica en GitHub Pages.',
    siteHelpTip: 'Usa uno u otro: con el workflow, deja esta opción sin marcar.',
    asPullRequest: 'Crear una rama para este cambio y proponer una pull request',
    toBranch: 'Guardar directamente en la rama {branch}',
    protectedNote: '{branch} está protegida: el cambio se propondrá como pull request.',
    experimental: 'Funcionalidad experimental',
    source: 'Código fuente',
    yourRepos: 'Tus recursos de eXeLearning',
    summary: '{n} recurso(s) en {r} repositorios',
    searchingMore: 'Buscando recursos en {n} repositorios más…',
    edit: 'Editar',
    noScreenshot: 'Sin captura de pantalla',
    otherRepos: 'Repositorios sin recursos de eXeLearning ({n})',
    gridView: 'Cuadrícula',
    listView: 'Lista',
    searching: 'buscando recursos…',
    noResource: 'sin recurso de eXeLearning',
    root: 'raíz',
    private: 'privado',
    moreAccess: 'Dar acceso a eXeLearning a más repositorios',
    noRepos: 'La app eXeLearning aún no tiene acceso a ningún repositorio.',
    publishPages: 'Publicar en GitHub Pages…',
    viewSite: 'Ver web',
    pagesTitle: 'Publicar en GitHub Pages',
    pagesIntro: 'GitHub puede regenerar y publicar la web cada vez que guardes. Haz estos dos pasos una vez en este repositorio:',
    pagesWorkflow: 'Añadir el flujo de publicación (GitHub lo abre ya preparado: pulsa "Commit changes")',
    pagesSettings: 'En Settings → Pages, elige Source: "GitHub Actions"',
    pagesResult: 'La web estará en {url}',
    close: 'Cerrar',
    cancel: 'Cancelar',
    committed: 'Guardado en {branch}.',
    pullRequest: 'Pull request abierta.',
    view: 'Ver en GitHub',
    loginNeeded: 'Inicia sesión con GitHub para continuar.',
    installNeeded: 'Da acceso a la app eXeLearning a {repo} en la ventana de GitHub.',
    noAccess: 'La app eXeLearning no puede escribir en {repo}. Instálala allí o descarga el .elpx.',
    noProject: 'No hay un proyecto de eXeLearning (content.xml) en {repo}{path}.',
    pickFolder: 'Proyectos encontrados en este repositorio:',
    rateLimited: 'GitHub limita el uso anónimo. Inicia sesión con GitHub para continuar.',
    notFound: 'No se encuentra el repositorio. Si es privado, inicia sesión con GitHub.',
    signIn: 'Iniciar sesión con GitHub',
    leaveWarning: 'Hay cambios sin guardar.',
    error: 'Error: {message}',
    notConfigured: 'Guardar en GitHub no está configurado en este servidor.',
};

const strings = navigator.language.toLowerCase().startsWith('es') ? es : en;
export const lang = strings === es ? 'es' : 'en';

export function t(key: keyof typeof en, vars: Record<string, string | number> = {}): string {
    return strings[key].replace(/\{(\w+)\}/g, (_, name) => String(vars[name] ?? ''));
}
